<template>
  <div>
    <meu-painel>
      <h4>Escolha uma opção de tipo de envio</h4>
      <v-radio-group v-model="tipoEnvio">
        <v-radio label="SCR assinado - upload do documento escaneado (PDF)"></v-radio>
        <v-radio label="Foto do SCR Assinado (PNG, JPG ou JPEG)"></v-radio>
        <!-- <v-radio label="Selfie com documento pessoal"></v-radio> -->
      </v-radio-group>

      <h4 v-show="this.tipoEnvio !== ''">Insira um arquivo para avançar</h4>

      <v-file-input
        :disabled="tipoEnvio === '' ? true : false"
        v-model="file"
        required
        :accept="tipoEnvio === 0 ? 'application/pdf' : 'image/*'"
        :capture="tipoEnvio === 2 ? 'camera' : false"
        :label="tipoEnvio === 2 ? 'Tirar foto' : 'Inserir arquivo' "
        :prepend-icon="tipoEnvio === 0 ? 'mdi-paperclip' : 'mdi-camera' "
        v-on:change="enviaDoc"
      ></v-file-input>
    </meu-painel>
  </div>
</template>

<script>
import rules from "../mixins/rules";
import Painel from "../components/Painel.vue";

export default {
  components: {
    "meu-painel": Painel
  },

  data() {
    return {
      file: [],
      tipoEnvio: "",
      dadosProdutor: {},
      URL: null
    };
  },

  mounted() {
    const produtor = localStorage.getItem("produtor");
    this.dadosProdutor = JSON.parse(produtor);
  },

  methods: {
    enviaDoc() {
      this.$router.push({
        name: "confirmacao",
        params: {
          file: this.file,
          tipoEnvio: this.tipoEnvio
        }
      });
    }
  }
};
</script>

<style>
* {
  outline: none;
}

.home {
  width: 70%;
  margin: 30px auto 30px auto;
}

.botao {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
</style>